<template>
  <!-- template for the modal component -->
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper mt-n12" style="height: 100vh">
        <v-card class="modal-container text-center mb-5" width="90vw" max-width="900" color="background" elevation="0">
          <v-btn elevation="0" fab color="error" small class="modal-default-button title ma-4"
            style="position: absolute; top: 0; left: 0" @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-card-text class="display-1"> Till Functions </v-card-text>
          <div class="d-flex justify-space-between">
            <v-card elevation="0" class="text-center pa-4" width="350">
              <v-card-text class="headline"> Add Transaction </v-card-text>
              <v-card-text class="red--text mt-n8">
                Use this to record a transaction against the terminal
              </v-card-text>
              <v-text-field class="mb-4 input" required outlined hide-details label="Amount" type="number" min="1"
                step="0.01" :rules="[rules.required]" prefix="$" placeholder="0.00" v-model="enteredAmt" autofocus
                @click="showAmtOsk()"></v-text-field>
              <!-- <v-text-field  label="Reason" required :rules="[rules.required]" placeholder="Comments" v-model="enteredComment" @click="showReasonOsk()"></v-text-field> -->
              <div class="d-flex justify-space-between">
                <v-btn elevation="0" color="#465169" class="white--text ma-2" large @click="
                  addTransaction(
                    enteredAmt,
                    'Draw' + enteredComment,
                    'Increase'
                  )
                ">
                  Draw
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                <v-btn elevation="0" color="#465169" class="white--text ma-2" large @click="
                  addTransaction(
                    enteredAmt,
                    'Return' + enteredComment,
                    'Decrease'
                  )
                ">
                  Return
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </div>
              <v-btn :disabled="enteredAmt === null" elevation="0" color="#465169" class="white--text ma-2" large @click="
                  refundVoucher(
                    enteredAmt)
                ">
                  Generate Voucher
                  <v-icon>mdi-file-outline</v-icon>
                </v-btn>
              <div style="width: 100%; margin: 0 auto">
                <SimpleKeyboardAMT @onChange="onChange" :input="enteredAmt" />
              </div>
            </v-card>
            <div>

              <v-card elevation="0">
                <v-card-text class="headline"> Calculator </v-card-text>
                <CalculatorCard />
                <v-spacer></v-spacer>
                <v-btn class="my-10" elevation="0" x-large :disabled="printingCashPos" color="success"
                  @click="printCashPosition()">
                  <v-card-text class="headline white--text font-weight-bold">
                    Print {{ printName("Cash Position") }}
                  </v-card-text>
                </v-btn>
                <div class="pa-2 pt-0 ">
                  <v-btn elevation="0" class="mr-2 white--text" color="#465169" :large="$vuetify.breakpoint.xl"
                    @click="printTest()">Test Print
                    <v-progress-circular v-if="printing" :size="20" indeterminate color="white"
                      class="ml-2"></v-progress-circular>
                  </v-btn>
                  <v-btn elevation="0" v-if="ejectOn" class="mr-2 white--text" color="blue"
                    :large="$vuetify.breakpoint.xl" @click="eject()">Eject</v-btn>
                </div>
              </v-card>
            </div>

          </div>
        </v-card>
      </div>
      <v-dialog v-model="errorModal" transition="none" max-width="400">
        <v-card>
          <v-card-title class="headline">No Transaction History!</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn elevation="0" color="green darken-1" large class="white--text" @click="errorModal = false">
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </transition>
</template>

<script>
import axios from "axios";
import { mapGetters, mapState, mapActions } from "vuex";
// import SimpleKeyboard from "./SimpleKeyboard"
import SimpleKeyboardAMT from "./SimpleKeyboardAMT";
import CalculatorCard from "./CalculatorCard.vue";
import moment from "moment";
import { NAMINGS } from "../common/constants";
import {
  generateCashPosition,
  generateMoneyRoomDrawReturnReceipt,
  generateTellerDrawReturnReceipt,
  generateCustomerBetReceipt,
  generateVoucher
} from "../common/tickets";

export default {
  computed: {
    ...mapState(["cashPosition"]),
    ...mapGetters(["getTerminalId", "getTerminalLocation", "getVenueName"]),
    ejectOn() {
      if (window.rt) return true;
      return false;
    },
  },
  props: {
    successfulTrans: Function,
    errorTrans: Function,
    userName: String,
  },
  components: {
    // SimpleKeyboard,
    SimpleKeyboardAMT,
    CalculatorCard,
  },
  data() {
    return {
      title: "Preliminary report",
      email: "",
      printingCashPos: false,
      showOskForAmount: false,
      showOskForReason: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
      formHasErrors: false,
      enteredComment: "",
      enteredAmt: null,
      errorModal: false,
      printing: false,
    };
  },
  methods: {
    ...mapActions(["setCashPosition", "getTerminalToken"]),
    eject() {
      if (window.rt?.printImage) {
        window.rt.eject();
      } else {
        console.log("not RT");
      }
    },
    async printTest() {
      this.printing = true;
      if (window.rt?.printImage) {
        const bet = {
          id: 1234,
          meeting: {
            track: {
              country: "AUS",
              name: "Doomben",
            },
            type: "THOROUGHBRED",
          },
          odds: 8.5,
          raceName: "Betmakers Bonanza",
          runnerName: "Brilliant",
          runnerNumber: "4",
          stake: "200.00",
          startTime: "2022-05-30T04:20:00Z",
          status: "unresulted",
          ticketId: "1965-5262-532-5",
          time: 1653883837189,
          trackCountry: "AUS",
          trackName: "Doomben",
          trackNumber: 6,
          winPlc: "w",
        };
        const startTime = this.formatStartTime(moment(bet.startTime));
        window.rt
          .printImage(
            generateCustomerBetReceipt(
              bet,
              this.getTerminalLocation,
              "123456789",
              this.$route.query.venue,
              startTime
            )
          )
          .then(() => {
            this.printing = false;
          })
          .catch(() => {
            this.printing = false;
            alert("test print failed");
          });
      } else {
        alert("no rt printer");
      }
    },
    formatStartTime: function (date) {
      return moment(date, "YYYY-MM-DD H:mm:ss").format("LLL");
    },
    
    async refundVoucher(amount) {
      let strToNum = new Number(amount);
      const amountTocents = parseInt(amount * 100);
      const idempotencyId = Date.now().toString(36) + Math.random().toString(36).substring(2);
      console.log(amountTocents);

      const sendRequest = async (idempotencyId) => {
        const token = await this.getTerminalToken();
        const transaction = {
          terminal_token: token,
          amount: strToNum.toFixed(2),
          reason: 'Voucher Created',
          type: 'Voucher',
        };
        return axios
          .post(`${process.env.VUE_APP_LEDGER_ENDPOINT}public/IssueVoucher`, {
            terminal_token: token,
            amount: amountTocents,
            idempotency_id: idempotencyId,
          })
          .then((res) => {
            const updatedBet = {
              ...this.data,
              ticketId: res.data.ticketId,
              status: 'Voucher',
              error: null,
              refundOwing: null,
              payout: amount
            }
            console.log('voucherCreated', updatedBet)
            this.printing = true
            const transactionReceipt = { ...transaction, date: Date.now() };
            if (window.rt?.printImage) {
              const custVoucher = generateVoucher(
                updatedBet,
                this.getTerminalLocation,
                this.$route.query.venue,
              );
              const tellerCopy = generateTellerDrawReturnReceipt(
                transactionReceipt,
                this.getTerminalLocation,
                this.userName
              );
              const mrCopy = generateMoneyRoomDrawReturnReceipt(
                transactionReceipt,
                this.getTerminalLocation,
                this.userName
              );
              window.rt.printImage(tellerCopy).then(() => {
                window.rt.printImage(mrCopy);
              });
              window.rt.printImage(custVoucher).then(() => {
              });
            } else if (window.bmElectron && !window.rt?.printImage) {
              window.bmElectron.send("print-request", "printing");
            } else {
              console.log('printLocal')
              window.print();
            }
          })
          .catch((error) => {
            console.log(error);
            if (error.response && error.response.status === 504) {
              // If it's a rate limit error (you can adjust the condition as needed)
              // You can add a delay and retry the request with the same idempotency ID
              setTimeout(() => {
                sendRequest(idempotencyId);
              }, 1000); // Wait for 1 second before retrying (adjust as needed)
            }
          });
      };

      // Initial request
      await sendRequest(idempotencyId);
    },
    async addTransaction(transAmt, comments, typeId) {
      let strToNum = new Number(transAmt);
      if (this.enteredAmt != null) {

        const token = await this.getTerminalToken()
        const transaction = {
          terminal_token: token,
          amount: strToNum,
          reason: comments,
          type: typeId,
        };
        await axios
          .post(
            `${process.env.VUE_APP_LEDGER_ENDPOINT}public/AdjustFloat`,
            transaction
          )
          .then(() => {
            this.successfulTrans();
            this.adjustThisTill(transAmt);
            const transactionReceipt = { ...transaction, date: Date.now() };
            if (window.rt?.printImage) {
              const tellerCopy = generateTellerDrawReturnReceipt(
                transactionReceipt,
                this.getTerminalLocation,
                this.userName
              );
              const mrCopy = generateMoneyRoomDrawReturnReceipt(
                transactionReceipt,
                this.getTerminalLocation,
                this.userName
              );
              window.rt.printImage(tellerCopy).then(() => {
                window.rt.printImage(mrCopy);
              });
            } else if (window.bmElectron && !window.rt?.printImage) {
              window.bmElectron.send("print-request", "printing");
            } else {
              window.print();
            }
            this.$emit("close");
          })
          .catch((err) => {
            console.log(err);
            this.errorTrans();
            this.$emit("close");
          });
      }
    },
    printName(v) {
      const name = NAMINGS;
      const print = name.find(
        (c) => c.word === v && c.venueName === this.getVenueName
      )?.replaceWith;
      return print || v;
    },
    adjustThisTill(v) {
      if (!window.adjustTill) {
        window.adjustTill = console.log;
      }
      window.adjustTill(v);
    },
    onChange(enteredAmt) {
      this.enteredAmt = enteredAmt;
    },
    onChangeReason(enteredComment) {
      this.enteredComment = enteredComment;
    },
    showReasonOsk() {
      this.showOskForAmount = false;
      this.showOskForReason = true;
    },
    showAmtOsk() {
      this.showOskForAmount = true;
      this.showOskForReason = false;
    },
    printCashPosition() {
      this.getTransactionHistory();
    },
    async getTransactionHistory() {
      this.printingCashPos = true;
      const todayDate = moment().startOf("day").format();

      const terminalToken = await this.getTerminalToken()
      await axios
        .post(
          `${process.env.VUE_APP_LEDGER_ENDPOINT}public/GetTransactions`,
          {
            terminal_id: terminalToken,
            trans_date: todayDate,
          }
        )
        .then((result) => {
          this.setCashPosition(true);
          if (result.data.TxnDetails.length > 0) {
            if (window.rt?.printImage) {
              const cashPos = generateCashPosition(
                result.data.TxnDetails,
                this.getTerminalLocation,
                this.getVenueName,
                this.userName
              );
              window.rt.printImage(cashPos).then(
                () => console.log("cash pos printed"),
                (e) => {
                  console.log("print error");
                  console.log(e);
                  this.error = `Print error: ${e}`;
                  this.errorModal = true;
                  this.printingCashPos = false;
                }
              );
            } else if (window.bmElectron && !window.rt?.printImage) {
              window.bmElectron.send("print-request", "printing");
            } else {
              window.print();
            }
          } else {
            this.errorModal = true;
          }
          this.printingCashPos = false;
        })
        .catch((err) => {
          console.log("received error");
          console.log(err);
          this.error = err.response.data;
          this.errorModal = true;
          this.printingCashPos = false;
        });
    },
  },
};
</script>

<style>
.modal-enter-active,
.modal-leave-active {
  transition: none !important;
}
</style>
